import React, { useState } from 'react';
import { PRICING_TIERS, BILLING_NOTE } from '../../data/pricingTiers';
import SignupModal from './SignupModal';

export default function PricingSection({ showHeading = true }) {
  const [annual, setAnnual] = useState(true);
  const [signupTier, setSignupTier] = useState(null);

  return (
    <section className="lp-pricing" id="pricing">
      {showHeading && (
        <div className="lp-section__head">
          <p className="lp-eyebrow">Pricing</p>
          <h2>Simple, credit-based pricing that scales with your team</h2>
          <p className="lp-section__sub">
            Every plan includes the full skill registry, governance, and audit trail.
            You only pay more as you route more work through agents.
          </p>
        </div>
      )}

      <div className="lp-billing-toggle" role="group" aria-label="Billing period">
        <button
          type="button"
          className={`lp-billing-toggle__opt ${!annual ? 'lp-billing-toggle__opt--active' : ''}`}
          onClick={() => setAnnual(false)}
        >
          Monthly
        </button>
        <button
          type="button"
          className={`lp-billing-toggle__opt ${annual ? 'lp-billing-toggle__opt--active' : ''}`}
          onClick={() => setAnnual(true)}
        >
          Annual
          <span className="lp-billing-toggle__badge">−20%</span>
        </button>
      </div>

      <div className="lp-pricing-grid">
        {PRICING_TIERS.map((tier) => {
          const price = annual ? tier.annualMonthly : tier.monthly;
          const isEnterprise = tier.key === 'enterprise';
          return (
            <article
              key={tier.key}
              className={[
                'lp-price-card',
                tier.highlight ? 'lp-price-card--highlight' : '',
                isEnterprise ? 'lp-price-card--enterprise' : '',
              ]
                .filter(Boolean)
                .join(' ')}
            >
              {tier.highlight && (
                <span className="lp-price-card__ribbon">Recommended</span>
              )}
              <header className="lp-price-card__head">
                <h3>{tier.name}</h3>
                <p className="lp-price-card__tagline">{tier.tagline}</p>
              </header>

              <div className="lp-price-card__amount">
                {price == null ? (
                  <span className="lp-price-card__custom">Custom</span>
                ) : (
                  <>
                    <span className="lp-price-card__currency">$</span>
                    <span className="lp-price-card__value">{price}</span>
                    <span className="lp-price-card__period">/mo</span>
                  </>
                )}
              </div>
              {price != null && annual && (
                <p className="lp-price-card__billed">
                  Billed annually · ${price * 12}/yr
                </p>
              )}
              {price != null && !annual && (
                <p className="lp-price-card__billed">Billed monthly</p>
              )}
              {price == null && (
                <p className="lp-price-card__billed">Quote based on seats & credits</p>
              )}

              {tier.credits && (
                <p className="lp-price-card__credits">
                  <strong>{tier.credits}</strong> credits / month
                </p>
              )}

              <button
                type="button"
                className={`lp-btn ${
                  tier.highlight || isEnterprise ? 'lp-btn--primary' : 'lp-btn--ghost'
                } lp-price-card__cta`}
                onClick={() => setSignupTier(tier)}
              >
                {tier.cta}
              </button>

              <ul className="lp-price-card__features">
                {tier.features.map((f) => (
                  <li key={f}>
                    <span className="lp-price-card__check" aria-hidden="true" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
            </article>
          );
        })}
      </div>

      <p className="lp-pricing__note">{BILLING_NOTE}</p>

      {signupTier && (
        <SignupModal
          plan={signupTier}
          billingCycle={annual}
          onClose={() => setSignupTier(null)}
        />
      )}
    </section>
  );
}
